import React from 'react';

const STORAGE_KEY = 'theme';
const LIGHT_CLASS = 'theme-light';

const readThemeFromDOM = () => {
  if (typeof document === 'undefined') return 'dark';
  return document.documentElement.classList.contains(LIGHT_CLASS)
    ? 'light'
    : 'dark';
};

const applyTheme = next => {
  const root = document.documentElement;
  if (next === 'light') {
    root.classList.add(LIGHT_CLASS);
  } else {
    root.classList.remove(LIGHT_CLASS);
  }
  const favicon = document.getElementById('favicon-svg');
  if (favicon) {
    favicon.href = next === 'light' ? '/favicon-light.svg' : '/favicon.svg';
  }
};

const SunIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="4" />
    <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41" />
  </svg>
);

const MoonIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
  </svg>
);

const ThemeToggle = () => {
  const [theme, setTheme] = React.useState('dark');
  const [mounted, setMounted] = React.useState(false);

  React.useEffect(() => {
    setMounted(true);
    setTheme(readThemeFromDOM());
  }, []);

  const toggle = () => {
    const next = theme === 'light' ? 'dark' : 'light';
    setTheme(next);
    applyTheme(next);
    try {
      localStorage.setItem(STORAGE_KEY, next);
    } catch (e) {
      /* localStorage unavailable — ignore */
    }
  };

  const isLight = mounted && theme === 'light';
  const label = isLight ? 'Switch to dark mode' : 'Switch to light mode';

  return (
    <button
      type="button"
      className="theme-toggle"
      onClick={toggle}
      aria-label={label}
      title={label}
    >
      <span
        className={`theme-toggle-side ${isLight ? 'is-active' : ''}`}
        aria-hidden="true"
      >
        <SunIcon />
      </span>
      <span
        className={`theme-toggle-side ${!isLight ? 'is-active' : ''}`}
        aria-hidden="true"
      >
        <MoonIcon />
      </span>
    </button>
  );
};

export default ThemeToggle;
